import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'
//import { fromJS } from 'immutable';

export default (formBody) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    let formdata = new FormData();
    formdata.append('newpassword',formBody.get('new-password'));
    formdata.append('username',formBody.get('username'))

    const Authorization = UserToken;
    const url = ApiUrl2 + 'users-reset-password';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : formdata
    };

    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};